const containsUnsupportedCharacters = (text: string): boolean => {
    const regex = /\p{Extended_Pictographic}/gu;

    return regex.test(text);
};

export default containsUnsupportedCharacters;
